import PropTypes from "prop-types";
import React, { Fragment } from "react";
import styles from "./feeds-seo-care-information.module.css";

function FeedsSeoCareInformation({ careInformation }) {
    let title = null;
    if (careInformation.title) {
        title = <h3>{careInformation.title}</h3>;
    }

    let items = null;
    if (careInformation.items.length > 0) {
        items = (
            <dl>
                {careInformation.items.map((item, index) => {
                    if (item.title || item.body) {
                        return (
                            <Fragment key={index}>
                                <dt className={styles.careInformationTitle}>{item.title}</dt>
                                <dd
                                    className={styles.careInformationBody}
                                    dangerouslySetInnerHTML={{ __html: item.body }}
                                ></dd>
                            </Fragment>
                        );
                    }
                })}
            </dl>
        );
    }

    if (title || items) {
        return (
            <div className={styles.careInformation}>
                {title}
                {items}
            </div>
        );
    }

    return null;
}

FeedsSeoCareInformation.propTypes = {
    careInformation: PropTypes.shape({
        title: PropTypes.string,
        items: PropTypes.arrayOf(
            PropTypes.shape({
                title: PropTypes.string,
                body: PropTypes.string,
            })
        ),
    }),
};

export default FeedsSeoCareInformation;
